// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"6cd3be80","905":"4f07612c"}[chunkId] + ".chunk.js";
};